import { useState, type MouseEvent, type ComponentProps } from "react";
import { useLogin, useNotify } from "ra-core";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";

export const OAuthButton = ({
  children,
  provider,
  redirect: redirectTo,
  ...props
}: OAuthButtonProps) => {
  const login = useLogin();
  const notify = useNotify();
  const [isPending, setIsPending] = useState(false);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setIsPending(true);
    login(
      { oauthProvider: provider },
      redirectTo ?? window.location.toString(),
    ).catch((error) => {
      setIsPending(false);
      if (error) {
        notify(
          typeof error === "string"
            ? error
            : typeof error === "undefined" || !error.message
              ? "ra.auth.sign_in_error"
              : error.message,
          {
            type: "error",
            messageArgs: {
              _:
                typeof error === "string"
                  ? error
                  : error && error.message
                    ? error.message
                    : undefined,
            },
          },
        );
      }
    });
  };

  return (
    <Button
      type="button"
      variant="outline"
      onClick={handleClick}
      disabled={isPending}
      {...props}
    >
      {children}
      {isPending ? (
        <Spinner className="size-4" data-icon="inline-start" />
      ) : null}
    </Button>
  );
};

export type OAuthButtonProps = {
  provider: "google" | "github" | "azure" | "apple";
  redirect?: string;
} & ComponentProps<typeof Button>;
